import type { SubTopic } from '../data/cards';

// 학생 화면용 순화 표현. 공모전 공식 주제명(생활폐기물 감축·지속가능소비 등)은
// 교사용 문서(수업지도안·설명서)와 인쇄물에서만 쓰고, ①②③ 번호로만 대응시킨다.
const LABELS: Record<SubTopic, string> = {
  reduction_practice: '① 쓰레기 줄이기',
  awareness_capacity: '② 올바르게 버리기',
  circular_economy: '③ 자원의 순환',
};

export function subTopicLabels(subTopics: SubTopic[]): string {
  return subTopics.map((topic) => LABELS[topic]).join(' · ');
}

export function subTopicLabel(subTopic: SubTopic): string {
  return LABELS[subTopic];
}

export const SUB_TOPIC_ORDER: SubTopic[] = ['reduction_practice', 'awareness_capacity', 'circular_economy'];
